import React, { useState } from 'react';
import { Table, Button } from '@themesberg/react-bootstrap';
import { ArrowUp, ArrowDown } from 'lucide-react';

const DataTableService = ({ data }) => {
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'ascending' });

  const sortedData = React.useMemo(() => {
    let sortableItems = [...data];
    if (sortConfig.key !== null) {
      sortableItems.sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
      });
    }
    return sortableItems;
  }, [data, sortConfig]);

  const requestSort = (key) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  };

  const getSortIcon = (name) => {
    if (sortConfig.key === name) {
      return sortConfig.direction === 'ascending' ? <ArrowUp size={16} /> : <ArrowDown size={16} />;
    }
    return null;
  };

  return (
    <Table striped bordered hover className="mt-3">
      <thead>
        <tr>
          <th>
            <Button variant="link" onClick={() => requestSort('name')}>
              Name {getSortIcon('name')}
            </Button>
          </th>
          <th>
            <Button variant="link" onClick={() => requestSort('total')}>
              Total {getSortIcon('total')}
            </Button>
          </th>
          <th>
            <Button variant="link" onClick={() => requestSort('percentage')}>
              Percentage {getSortIcon('percentage')}
            </Button>
          </th>
        </tr>
      </thead>
      <tbody>
        {sortedData.map((item, index) => (
          <tr key={index}>
            <td>{item.service__name}</td>
            <td>{item.total}</td>
            <td>{item.percentage.toFixed(2)}%</td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default DataTableService;